module.exports = __webpack_public_path__ + "img/22.f71def67.png";